/**
 * ============================================================================
 * TaskFlow ERP
 * Module : Campaign Management
 * Feature: Prospect Import
 *
 * File:
 * src/modules/campaign/prospectImport/pages/ProspectImportPage.jsx
 *
 * Description:
 * Entry page for Prospect Import.
 * ============================================================================
 */

import React from "react";

import ImportWorkspace
from "../components/importWorkspace/ImportWorkspace";

import useProspectImport
from "../hooks/useProspectImport";

import importConfig
from "../constants/importConfig";

export default function ProspectImportPage() {

    const hook = useProspectImport();

    const state = {

        ...hook

    };

    const actions = {

        ...hook

    };

    return (

        <ImportWorkspace

            config={importConfig}

            state={state}

            actions={actions}

        />

    );

}